/* THIS FILE IS GENERATED. DO NOT EDIT */

import { PropsFromComponent } from '@/types/component';
import { withDebugMetadata } from '@/utils/withDebugMetadata';
import { withLabradorInstanceof } from '@/utils/withInstanceofProp';
import { LabradorList as ResolvedLabradorList } from 'base/components/labrador/List';

export const LabradorList: typeof ResolvedLabradorList = withLabradorInstanceof((props) => {
    return <ResolvedLabradorList {...props} {...withDebugMetadata({type: props.type, meta: props.meta})} />;
});

export type LabradorListProps = PropsFromComponent<typeof LabradorList>;
